<p-inputMask
  [disabled]="disabled" [(ngModel)]="timestampString" (onBlur)="onBlur()"
  mask="9:99:99" slotChar="0" (ngModelChange)="onModelChange()"
></p-inputMask>
